import React, { useState } from 'react';

const Card = ({ day, dayInCurrentMonth, onClick = () => {}, isToday, data, haveData, overToday }) => {
  const [over, setOver] = useState(false);
  const isHoliday = day._d.getDay() === 0 || day._d.getDay() === 6;
  const titleColor = `${isHoliday ? '#ff0000' : (isToday ? 'white' : '#000000')}${dayInCurrentMonth ? '' : '50'}`;
  const disable = overToday;
  return (
    <div
      style={{ marginTop: 8, marginLeft: 8, marginRight: 8, backgroundColor: over ? '#C1C1C1' : 'transparent', cursor: disable ? 'default' : 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', borderRadius: 10 }}
      onMouseOver={disable ? () => {} : () => setOver(true)}
      onMouseOut={disable ? () => {} : () => setOver(false)}
      onClick={disable ? () => {} : onClick}
    >
      <div style={{ fontWeight: 700, fontSize: 20, color: titleColor, height: 28, width: 28, borderRadius: 15, backgroundColor: isToday ? '#4CC2CA' : 'transparent' }}>{day.format('D')}</div>
      {!overToday && haveData && (
        <div style={{ width: 90, height: 168, marginTop: 8, fontSize: 10, fontWeight: 700, backgroundColor: over ? '#C1C1C1' : (isHoliday ? '#F0F0F0' : 'transparent'), borderRadius: 10, textAlign: 'start' }}>
          <div>水下基礎PP/MP</div>
          <div style={{ display: 'flex' }}>
            <div style={{ color: 'red' }}>{data?.z1_have_do_allnum || 0}</div>
            /
            <div style={{ color: 'red' }}>{data?.z1_should_do_allnum || 0}</div>
          </div>
          <div>水下基礎Jacket</div>
          <div>/TP</div>
          <div style={{ display: 'flex' }}>
            <div style={{ color: 'red' }}>{data?.z2_have_do_allnum || 0}</div>
            /
            <div style={{ color: 'red' }}>{data?.z2_should_do_allnum || 0}</div>
          </div>
          <div>風力機</div>
          <div style={{ display: 'flex' }}>
            
            <div style={{ color: 'red' }}>
              {(data?.z3_wind_turbine_check === '1')? data?.z3_wind_turbine_num: 0 }
            </div>
            /
            <div style={{ color: 'red' }}>{data?.z3_should_do_allnum || 0}</div>
          </div>
          <div>併網</div>
          <div style={{ display: 'flex' }}>
            <div style={{ color: 'red' }}>{data?.z4_have_been_grid_conneciton_num || 0}</div>
            /
            <div style={{ color: 'red' }}>{data?.z4_have_do_allnum || 0}</div>
            /
            <div style={{ color: 'red' }}>{data?.z4_should_do_allnum || 0}</div>
          </div>
        </div>
      )}
      {!overToday && !haveData && (
        <div style={{ width: 90, height: 168, marginTop: 8, fontSize: 10, fontWeight: 700, backgroundColor: over ? '#C1C1C1' : (isHoliday ? '#F0F0F0' : 'transparent'), borderRadius: 10 }}>
          <div style={{ color: over ? 'white' : '#B8B8B8', fontSize: 15, fontWeight: 500 }}>點選日期</div>
          <div style={{ color: over ? 'white' : '#B8B8B8', fontSize: 15, fontWeight: 500 }}>新增進度</div>
        </div>
      )}
      {overToday && <div style={{ width: 90, height: 168, marginTop: 8, fontSize: 10, fontWeight: 700, backgroundColor: over ? '#C1C1C1' : (isHoliday ? '#F0F0F0' : 'transparent'), borderRadius: 10 }} />}
    </div>
  );
};
export default Card;
